import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { configureStore } from './store/StoreConfig';
import * as serviceWorker from './ServiceWorker';
import ConnectedApp from 'components/App';
import 'typeface-roboto';
import './index.css';
import 'font-awesome/css/font-awesome.min.css';
import "./slickgrid.scss"


const store = configureStore();

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <ConnectedApp />
    </Router>
  </Provider>,
  document.getElementById('root'),
);

serviceWorker.unregister();
